import { lazy, Suspense } from "react";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./markdown-editor.i18n";
import type { MarkdownEditorHeadings } from "./markdown-editor-with-toolbar";

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  showAI?: boolean;
  /**
   * Which headings the editor offers. `levels` is H1–H3 (default); `single` is
   * the one flow-page heading — flow copy (text block, modal) uses it. QL-296.
   */
  headings?: MarkdownEditorHeadings;
}

const LexicalMarkdownEditor = lazy(() =>
  import("./markdown-editor-lexical").then((mod) => ({ default: mod.LexicalMarkdownEditor })),
);

export function MarkdownEditor({
  value,
  onChange,
  placeholder,
  className,
  showAI = true,
  headings = "levels",
}: MarkdownEditorProps) {
  const t = useT(T);
  return (
    <Suspense
      fallback={
        <div className="rounded-md border border-input bg-background p-4 min-h-[200px] flex items-center justify-center text-muted-foreground">
          {t.loading}
        </div>
      }
    >
      <LexicalMarkdownEditor
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        showAI={showAI}
        headings={headings}
      />
    </Suspense>
  );
}
